import * as React from "react";
import { useRef, useCallback } from "react";
import styled from "styled-components";
import { useMetric } from "hooks/useMetrics";
import { Spinner } from "components/common";
import { formatCount, getValueFromMetric, prefixMetric } from "components/inputs/helpers/InputThroughputUtils";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
const StyledSpan = styled.span`
  cursor: pointer;
`;
const METRIC_NAME = "incomingMessages";
const ThroughputCell = ({ input }) => {
  var _a;
  const metricName = prefixMetric(input, METRIC_NAME);
  const { data: metrics, isLoading } = useMetric(metricName);
  const spanRef = useRef();
  const { toggleSection, expandedSections } = useExpandedSections();
  const toggleTrafficSection = useCallback(() => toggleSection(input.id, "traffic"), [input.id, toggleSection]);
  if (isLoading || Object.keys(metrics).length === 0) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  const incomingMessages = Object.keys(metrics).reduce((previous, nodeId) => {
    var _a2, _b;
    if (!((_a2 = metrics == null ? void 0 : metrics[nodeId]) == null ? void 0 : _a2[metricName])) {
      return previous;
    }
    const value = getValueFromMetric((_b = metrics == null ? void 0 : metrics[nodeId]) == null ? void 0 : _b[metricName]);
    if (value !== void 0) {
      return isNaN(previous) ? value : previous + value;
    }
    return previous;
  }, NaN) || 0;
  const throughputSectionIsOpen = (_a = expandedSections == null ? void 0 : expandedSections[input.id]) == null ? void 0 : _a.includes("traffic");
  return /* @__PURE__ */ React.createElement(
    StyledSpan,
    {
      ref: spanRef,
      title: `${throughputSectionIsOpen ? "Hide" : "Show"} metrics`,
      onClick: toggleTrafficSection
    },
    !isNaN(incomingMessages) ? formatCount(incomingMessages) : 0,
    " msg/s"
  );
};
export default ThroughputCell;
